import React from 'react';
import { setVisibleCustomers } from '../../../../../actions/ui';
import { getCustomer, searchCustomer } from '../../../../../helpers/customer-helper';
import { usePaginatedSearchList } from '../../../../../hooks/usePaginatedSearchList';
import { getCustomerStatusSummary } from '../helpers';

export const useCustomerListScreen = ({ token, dispatch }) => {
    const {
        items: customers,
        isLoading,
        error,
        pagination,
        lastResponse,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    } = usePaginatedSearchList({
        token,
        getItems: getCustomer,
        searchItems: searchCustomer,
        initialSearchField: 'code',
        initialStatusFilter: 'ALL',
        initialRowsPerPage: 10,
        debounceMs: 600,
    });

    const statusSummary = React.useMemo(() => getCustomerStatusSummary(lastResponse), [lastResponse]);

    React.useEffect(() => {
        dispatch(setVisibleCustomers(customers));
    }, [dispatch, customers]);

    React.useEffect(() => {
        return () => {
            dispatch(setVisibleCustomers([]));
        };
    }, [dispatch]);

    return {
        customers,
        isLoading,
        error,
        pagination,
        statusSummary,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    };
};
